var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolkadot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 5.40513C11.5885 5.40513 12.8762 4.66144 12.8762 3.74407C12.8762 2.82669 11.5885 2.08301 9.99996 2.08301C8.41147 2.08301 7.12374 2.82669 7.12374 3.74407C7.12374 4.66144 8.41147 5.40513 9.99996 5.40513Z",
    fill: "#E6007A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 17.9163C11.5885 17.9163 12.8762 17.1727 12.8762 16.2553C12.8762 15.3379 11.5885 14.5942 9.99996 14.5942C8.41147 14.5942 7.12374 15.3379 7.12374 16.2553C7.12374 17.1727 8.41147 17.9163 9.99996 17.9163Z",
    fill: "#E6007A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99111 7.70246C6.78536 6.33707 6.78033 4.85835 5.97987 4.39966C5.17942 3.94097 3.88666 4.67601 3.09241 6.0414C2.29817 7.4068 2.3032 8.88551 3.10365 9.3442C3.90411 9.80289 5.19687 9.06786 5.99111 7.70246Z",
    fill: "#E6007A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9076 13.9581C17.7018 12.5927 17.6968 11.1139 16.8964 10.6553C16.0959 10.1966 14.8031 10.9316 14.0089 12.297C13.2146 13.6624 13.2197 15.1411 14.0201 15.5998C14.8206 16.0585 16.1133 15.3235 16.9076 13.9581Z",
    fill: "#E6007A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97987 15.5997C6.78032 15.141 6.78535 13.6623 5.99111 12.2969C5.19686 10.9315 3.9041 10.1965 3.10365 10.6552C2.30319 11.1139 2.29816 12.5926 3.09241 13.958C3.88666 15.3234 5.17942 16.0584 5.97987 15.5997Z",
    fill: "#E6007A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8963 9.34425C17.6967 8.88556 17.7018 7.40685 16.9075 6.04145C16.1133 4.67606 14.8205 3.94102 14.0201 4.39971C13.2196 4.8584 13.2146 6.33712 14.0088 7.70251C14.8031 9.06791 16.0958 9.80294 16.8963 9.34425Z",
    fill: "#E6007A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkadot);
export default __webpack_public_path__ + "static/media/polkadot.5cc827f028746f2435a82a00c948ffc2.svg";
export { ForwardRef as ReactComponent };